import React, { useEffect, useState } from "react";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { server } from "../common";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AiFillDelete } from "react-icons/ai";
import { useSelectAccess } from "../store/stateFunctions";
import { Button, Modal } from "react-bootstrap";

const swalalert = withReactContent(Swal);

const ViewMembershipRegistrations = ({ role }) => {
  const user = useSelectAccess("Super Admin");
  const [data, setData] = useState([]);
  const [membership, setMembership] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [filters, setFilters] = useState({
    name: "",
    mobile: "",
    occupation: "",
      bloodgroup: "",
  });
  const [show, setShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const handleClose = () => setShow(false);
  const handleShow = (item) => {
    setShow(true);
    setSelectedId(item);
  };

  useEffect(() => {
    getData();
    if (selectedId) {
      getDataById(selectedId);
      setShow(true);
    }
  }, [selectedId]);

  // Get
  const getData = (page = 1) => {
    server
      .get(`/membership/getallmembership?page=${page}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data?.data || []);
          setCurrentPage(response.data?.currentPage || 1);
          setTotalPages(response.data?.totalPages || 1);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // const getData = () => {
  //   server
  //     .get("/membership/getallmembership", {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: user.authToken,
  //       },
  //     })
  //     .then(function (response) {
  //       console.log("api response", response.data);
  //       if (response.status === 200 || response.status === 201) {
  //          setData(response.data?.data);
  //       }
  //     })
  //     .catch(function (error) {
  //       if (error instanceof AxiosError && error.response?.data?.message)
  //         toast.error(error.response.data.message);
  //       else if (error.response?.data?.error) {
  //         toast.error(error.response.data.error);
  //       } else toast.error("Failed to connect to server");
  //     });
  // };

  const getDataById = (id) => {
    server
      .get(`/membership/getmembership/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          setMembership(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete gallery
  const deleteInternShip = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.link} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/membership/deletemembership/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                // "auth-Token": user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire(
                  "Deleted!",
                  "Contact entry has been deleted.",
                  "success"
                );
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/contact/admfilter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const getFilterData = (page = 1) => {
    const params = new URLSearchParams();
    if (filters.name) params.append("name", filters.name);
    if (filters.mobile) params.append("mobile", filters.mobile);
    if (filters.occupation) params.append("occupation", filters.occupation);
      if (filters.bloodgroup) params.append("bloodgroup", filters.bloodgroup); // 🔹 New line

    params.append("page", page);

    server
      .get(`/membership/filtermembership?${params.toString()}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setData(response.data?.data || []);
          setCurrentPage(response.data?.currentPage || 1);
          setTotalPages(response.data?.totalPages || 1);
        }
      })
      .catch((error) => {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // 🔹 Initial load
  useEffect(() => {
    getFilterData(1);
  }, []);

  // 🔹 Handle filter input
  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  // 🔹 Apply filter button
  const handleFilter = () => {
    getFilterData(1);
  };
  return (
    <div>
      <div className="container">
        <h2 className="text-center py-4">Membership Registrations</h2>

        <div className="card p-3 mb-3">
          <h5>Filter Membership</h5>
          <div className="row g-3">
            <div className="col-md-3">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Enter Name"
                value={filters.name}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-3">
              <input
                type="text"
                className="form-control"
                name="mobile"
                placeholder="Enter Mobile"
                value={filters.mobile}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-2">
              <input
                type="text"
                className="form-control"
                name="occupation"
                placeholder="Enter Occupation"
                value={filters.occupation}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-2">
      <select
        className="form-select"
        name="bloodgroup"
        value={filters.bloodgroup}
        onChange={handleChange}
      >
        <option value="">Select Blood Group</option>
        <option value="A+">A+</option>
        <option value="A-">A-</option>
        <option value="B+">B+</option>
        <option value="B-">B-</option>
        <option value="O+">O+</option>
        <option value="O-">O-</option>
        <option value="AB+">AB+</option>
        <option value="AB-">AB-</option>
      </select>
    </div>
            <div className="col-md-2">
              <button className="btn btn-primary w-100" onClick={handleFilter}>
                Apply Filter
              </button>
            </div>
          </div>
        </div>
        <table className="table table-striped table-bordered border">
          <thead>
            <tr>
              <th scope="col">Sr. No.</th>
              <th scope="col">Full Name</th>
              <th scope="col">Mobile</th>
                            <th scope="col">Blood Group</th>
              <th scope="col">Address</th>
              <th scope="col">Occupation</th>
              <th scope="col">Delete</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.map((item, index) => {
                return (
                  <>
                    <tr key={item.id}>
                      <td>{(currentPage - 1) * 15 + index + 1}</td>
                      <td>{item.fullname}</td>
                      <td>{item.mobile}</td>
                       <td>{item.bloodgroup}</td>
                      <td>{item.address}</td>
                      <td>{item.occupation}</td>
                      <td>
                        <div
                          className="btn banner text-white"
                          onClick={() => handleShow(item.id)}
                        >
                          View
                        </div>
                      </td>
                    </tr>
                  </>
                );
              })}
          </tbody>
        </table>
        <div className="d-flex justify-content-between align-items-center mt-3">
          <button
            className="btn btn-primary"
            disabled={currentPage === 1}
            onClick={() => getData(currentPage - 1)}
          >
            Previous
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className="btn btn-primary"
            disabled={currentPage === totalPages}
            onClick={() => getData(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Membership Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {membership ? (
            <table className="table table-bordered table-striped">
              <tbody>
                <tr>
                  <th>Full Name</th>
                  <td>{membership.fullname}</td>
                  <th>Mobile</th>
                  <td>{membership.mobile}</td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>{membership.email || "N/A"}</td>
                  <th>DOB</th>
                  <td>{membership.dob}</td>
                </tr>
                <tr>
                  <th>Blood Group</th>
                  <td>{membership.bloodgroup}</td>
                  <th>Occupation</th>
                  <td>{membership.occupation}</td>
                </tr>
                <tr>
                  <th>Hobby</th>
                  <td>{membership.hobby}</td>
                  <th>No. of Family Members</th>
                  <td>{membership.nooffamilymember}</td>
                </tr>{" "}
                <tr>
                  <th>Photo</th>
                  <td>
                    <a href={membership.image} target="_blank">
                      View
                    </a>
                  </td>
                  <th>No. of Family Members</th>
                  <td>{membership.nooffamilymember}</td>
                </tr>
                <tr>
                  <th>Address</th>
                  <td colSpan={3}>{membership.address}</td>
                </tr>
                <tr>
                  <th>Permanent Address</th>
                  <td colSpan={3}>{membership.permenent_adress}</td>
                </tr>
                <tr>
                  <th>State</th>
                  <td>{membership.state}</td>
                  <th>District</th>
                  <td>{membership.district}</td>
                </tr>
                <tr>
                  <th>Taluka</th>
                  <td>{membership.taluka}</td>
                  <th>Village</th>
                  <td>{membership.village}</td>
                </tr>
                <tr>
                  <th>Ward No</th>
                  <td>{membership.wardno}</td>
                  <th>Reference</th>
                  <td>{membership.reference || "N/A"}</td>
                </tr>
                {membership.occupation === "Business" && (
                  <>
                    <tr>
                      <th>Services</th>
                      <td colSpan={3}>{membership.services}</td>
                    </tr>
                    <tr>
                      <th>Company Name</th>
                      <td>{membership.companyname}</td>
                      <th>Office Type</th>
                      <td>{membership.officetype}</td>
                    </tr>
                    <tr>
                      <th>Office Address</th>
                      <td colSpan={3}>{membership.officeaddress}</td>
                    </tr>
                  </>
                )}
                {membership.occupation === "Job" && (
                  <tr>
                    <th>Job Company Name</th>
                    <td>{membership.jobcompanyname}</td>
                    <th>Job Position</th>
                    <td>{membership.jobposition || "N/A"}</td>
                  </tr>
                )}
              </tbody>
            </table>
          ) : (
            <p>Loading...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ViewMembershipRegistrations;
